import script from "./CatalogoBuscador.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogoBuscador.vue?vue&type=script&setup=true&lang=js"

import "./CatalogoBuscador.vue?vue&type=style&index=0&id=1e8696e8&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e8696e8"]])

export default __exports__